export interface INotificationElements {
  action: string
  icon: string
  message: string
}

export interface INotificationModifiers {
  size: {
    xs: string
    sm: string
    base: string
    lg: string
    xl: string
  }
}

export interface INotificationVariants {
  outlined: {
    block: string
    modifiers: INotificationVariantModifiers
  }
  contained: {
    block: string
    modifiers: INotificationVariantModifiers
  }
}

export interface INotificationVariantModifiers {
  default: string
  success: string
  alert: string
  notice: string
}

export type NotificationTheme = any

export const NotificationTheme: NotificationTheme = {
  block: 'rounded-sm transition ease-in duration-100',
  elements: {
    action: 'flex',
    icon: 'text-base',
    message: 'flex flex-1 text-base'
  },
  modifiers: {
    size: {
      base: 'p-6 leading-5',
      lg: 'p-6 leading-6',
      sm: 'p-4 leading-4',
      xl: 'p-6 leading-6',
      xs: 'p-1 leading-4'
    }
  },
  variants: {
    contained: {
      block: 'shadow-lg text-text-default',
      modifiers: {
        alert: 'bg-error-muted',
        default: 'bg-teal-500',
        notice: 'bg-red-100 shadow-none text-gray-700',
        success: 'bg-green-500'
      }
    },
    outlined: {
      block: 'rounded-md border text-text-default',
      modifiers: {
        alert: 'bg-error-muted',
        default: 'bg-info-muted',
        notice: 'bg-warning-muted',
        success: 'bg-success-muted'
      }
    }
  }
}
